<template lang="pug">
    v-dialog( persistent max-width="850px" v-model="open" )
        v-toolbar( color="grey darken-4" dark sticky flat )
            v-toolbar-title Registro Nueva Isapre
            v-spacer
            v-btn( icon dark @click="toggleOpen")
                v-icon close
        v-card
            v-layout.pa-3( row wrap )
                v-flex( xs12 )
                    input-button.mt-2(
                        btnText="Crear"
                        @button:click="submitCreate"
                        v-model="inputIsapreType"
                        
                    )
</template>

<script>
import { InputButton } from '@/components/reusable_components'
import IsapreTypeService from '@/services/api/isapreType/IsapreTypeServices'
import {mapActions} from 'vuex'

export default {
    name: 'dialog-create-isapre',
    props: {},
    data: function() {
        return {
            open: false,
            inputIsapreType: "",
        }
    },
    computed: {},
    methods: {
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),
        toggleOpen() {
            this.open = !this.open
            this.inputIsapreType = ""
        },
        submitCreate: async function() {
            //- Campos
            console.log('input text: ', this.inputIsapreType)
            if(this.inputIsapreType === "" || this.inputIsapreType == null){
                console.log('No hay ingreso de datos.')
            }
            // Comprobar nuevo tipo de Isapre no esté creado anteriormente
            else if(this.inputIsapreType !== null) {
                let isapreName = await IsapreTypeService.findIsapreByName(this.inputIsapreType)
                if(isapreName.length > 0){
                    console.log('Isapre ya existe! Ingrese nueva Isapre!')
                    //- Rules to show 'Isapre already exist'
                }
                else {
                    // Crea nuevo tipo de Isapre
                    let response = await IsapreTypeService.createIsapreType({type: this.inputIsapreType})
                    console.log('response create: ', response)
                    if(response.status == "success"){
                    let snackInfo = this.fillSnack('success', 'Éxito', 'Isapre creada exitosamente.', false, 3000)
                    this.initSnackbar(snackInfo)
                    this.$emit('success')
                    this.inputIsapreType = ""
                    this.open = false
                    }
                    else{
                        let snackInfo = this.fillSnack('error', 'Error', response, false, 3000)
                        this.initSnackbar(snackInfo)
                    }
                    console.log(event)
                }
            }
        },
    },
    watch: {},
    components: {
        'input-button': InputButton,
    },
    mixins: [],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    // beforeMount: function(){
    //     this.getInvoiceRecentInformation()
    // },
    // mounted: function(){
    //     this.getInvoiceRecentInformation()
    // },
    // beforeUpdate: function(){...},
    updated: function() {
        //this.getInvoiceRecentInformation()
    },
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss">
</style>